<template>
  <div class="tobesigned-page">
    <div class="jjr-block">
      <div class="jjr-background">
        <div class="jjr-pram1">房屋合同进度</div>
        <div class="jjr-pram2">如遇到问题请联系经纪人</div>
      </div>
      <div class="jjr">
        <div class="rz-block">
          <div class="line-block">
            <!-- <div class="card-icon">
              <img
                class="card-icon-img"
                src="https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLY9ThKgsfPOXayH7tZyl4r2lQ67tzg5SibB0oR4KBm7bpJiakMSdIAfD0ic80jGHjJz1yMAdibsOx0icg/132"
                alt=""
              />
            </div> -->
            <div class="card-text">
              <div class="s-font">物业地址:{{ options.adress }}</div>
              <div class="s-font">户型:{{ options.huxing }}</div>
              <div class="s-font">面积：{{ options.mianji }}m²</div>
            </div>
            <!-- <div class="card-statu">
              <a class="jinjiren-phone" :href="'tel:' + options.jjr_phone">
                <div class="statu-text1">在线问</div>
              </a>
            </div>
            <div class="card-statu">
              <a class="jinjiren-sms" :href="'sms:' + options.jjr_phone">
                <div class="statu-text2">打电话</div>
              </a>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="ht-block">
      <div class="ht-line">
        <div class="ht-line-text">
          <div class="ht-line-text-title">实名认证</div>
          <div class="ht-line-text-content">
            请首先进行实名认证，确保认证数据为真实数据
          </div>
        </div>
        <div class="ht-line-button" v-if="!isSM" @click="goRZ">去认证</div>
        <div class="ht-line-button-end" v-if="isSM">已认证</div>
      </div>

      <div class="ht-line">
        <div class="ht-line-text">
          <div class="ht-line-text-title">上传产权证照片</div>
          <div class="ht-line-text-content">请确保上传产权证照片为真实数据</div>
        </div>
        <!-- <div class="ht-line-button">
          <el-upload
            class="avatar-uploader"
            :action="active_url"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <div>去上传</div>
          </el-upload>
        </div> -->

        <!-- <div class="ht-line-button-end" v-if="!isSM">已上传</div> -->
      </div>
      <div class="ht-line">
        <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          :before-delete="afterDelete"
          multiple
        />
      </div>

      <div class="ht-line">
        <div class="ht-line-text">
          <div class="ht-line-text-title" @click="gopdg()">合同详情</div>
          <div class="ht-line-text-content">合同编号:{{ options.htbh }}</div>
          <div class="ht-line-text-content">签署公司:{{ options.gsgs }}</div>
          <div class="ht-line-text-content">成交编号:{{ options.cjbh }}</div>
          <!-- <div class="ht-line-text-content">房源编号:{{ options.fybh }}</div> -->
          <div class="ht-line-text-content">签约日期:{{ options.qyrq }}</div>
          <div class="ht-line-text-content">
            经办人:{{ options.qsbm + "/" + options.jjr_name }}
          </div>
          <!-- <div class="ht-line-text-content">出售人:{{ options.qsr }}</div> -->
          <div class="ht-line-text-content">签约状态:{{ options.qyzt }}</div>
        </div>
        <div>
          <div class="ht-line-button-end" @click="getHT()">查看合同</div>
          <div v-if="options.tqxh != ''">
          <van-uploader class="avatar-uploader" :after-read="afterRead_WTS">
            <div  class="ht-line-button" style="margin-top: 0.4rem" v-if="WTSUrl == ''">上传委托书</div>
            <div  class="ht-line-button-end" @click="viewWTS()" style="margin-top: 0.4rem"s v-else>委托书已上传</div>
          </van-uploader>
          </div>
          <div
            style="margin-top: 0.4rem"
            class="ht-line-button"
            v-if="isSM && options.ssqurl != '' && options.qssj == ''"
            @click="quQY"
          >
            去签约
          </div>
        </div>
      </div>
    </div>

    <div class="jjr-block-bottom">
      <div class="rz-block">
        <div class="line-block">
          <div class="card-icon">
            <img
              class="card-icon-img"
              :src="
                options.jjr_pic == ''
                  ? '../images/avater_default.png'
                  : options.jjr_pic
              "
              alt=""
            />
          </div>
          <div class="card-text">
            <div class="lx-font">{{ options.jjr_name }}</div>
            <div class="s-font">{{ options.qsbm }}</div>
          </div>
          <div class="card-statu">
            <a class="jinjiren-phone" :href="'tel:' + options.jjr_phone">
              <div class="statu-text1">打电话</div>
            </a>
          </div>
          <div class="card-statu">
            <a class="jinjiren-sms" :href="'sms:' + options.jjr_phone">
              <div class="statu-text2">在线问</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="isShow"
      show-cancel-button
      :before-close="beforeClose"
      confirm-button-text="确认并同意"
    >
      <div v-if="company == ''">
        <ComponentA></ComponentA>
      </div>
      <div v-else>
        <ComponentB></ComponentB>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import actions from "../../common/test.js";
import util from "../../common/util.js";
import axios from "axios";
import { Dialog } from "vant";
import { ref } from "vue";
import ComponentA from "./3ctext_jxzf.vue";
import ComponentB from "./3ctext_jcfy.vue";
export default {
  setup() {
    const show = ref(false);
    return { show };
  },
  components: {
    ComponentA,
    ComponentB,
  },
  data() {
    return {
      options: this.$route.query,
      isSM: false,
      imageUrl: "",
      // active_url:
      //   "http://test.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=mmls&token=clientjcfy&gzhid=" +
      //   util.getLocalStorage("openid") +
      //   "&rw_id=" +
      //   this.$route.query.id,
      active_url:
        "http://wx.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=mmls&token=clientjcfy&gzhid=" +
        util.getLocalStorage("openid") +
        "&rw_id=" +
        this.$route.query.id,
      renzhenginfo: {},
      isShow: false,
      company: "",
      fileList: [],
      WTSUrl: "",
    };
  },
  mounted() {
    this.getSM();
    this.company = util.getLocalStorage("company");
  },
  methods: {
    getSM() {
      console.log(this.$route.query);
      let data = {
        gzhid: util.getLocalStorage("openid"),
        //gzhid:'ovgmM0756koHNWHF8vDXJXQA9kqE'
      };
      actions.getuser_info(data).then((info) => {
        console.log(info.content[0]);
        let status = info.content[0].is_smrz == "yes";
        this.isSM = status;
        this.renzhenginfo = info.content[0];
        this.getImg();
      });
    },
    getHT() {
      let data = {
        rw_id: this.options.id,
      };
      console.log(data);
      actions.contract_FJ(data).then((res) => {
        console.log(res);
        this.$router.push({ name: "facescan", query: { url: res.content } });
        // window.location.replace(res.content)
      });
    },
    quQY() {
      console.log(this.options)
      if(this.WTSUrl == '' && this.options.tqxh != ''){
        this.$message.error("请先上传委托书");
        return;
      } else {
         window.location.replace(this.options.ssqurl);
      }



      //window.open(this.options.ssqurl);

      // this.isShow = true;
    },

    beforeClose(action, done) {
      if (action === "confirm") {
        Dialog.alert({
          title: "调用成功",
          message: "CA证书申请成功且存储在上上签。",
        }).then(() => {
          this.isShow = false;
          setTimeout(() => {
            window.location.replace(this.options.ssqurl);
          }, 1000);
        });
      } else if (action === "cancel") {
        console.log("2");
        done(); // 关闭
      }
    },

    goRZ() {
      this.$router.push({ name: "myinfoupdate" });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // console.log(this.$route.query.id)
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      return true;
    },
    gopdg() {
      this.$router.push({ name: "facescan" });
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.ZimageUrl = URL.createObjectURL(file.file);
      var info = new FormData();
      info.append("sfz", file.file);
      axios({
        method: "post",
        // url:
        //   "http://test.jcfyht.cc/Contract/api/capi?api_name=uploadsfz&pic_type=sfzzm&token=clientjcfy&gzhid=" +
        //   util.getLocalStorage("openid"),
        url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=uploadrwpic&pic_type=sfzzm&token=clientjcfy&gzhid=" +
          util.getLocalStorage("openid") +
          "&rw_id=" +
          this.options.id,
        data: info,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then(() => {
        this.getImg();
      });
    },
    getImg() {
      let self = this;
      axios({
        method: "post",
        url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=viewrwpic&token=clientjcfy&rw_id=" +
          self.options.id,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          let list = res.data.content;
          list.map((item) => {
            item.url =
              "http://wx.beijinghome.cc/Contract/swfupload/files/" +
              item.pic_path;
          });
          console.log(list);

          self.fileList = list;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    afterDelete(file) {
      let self = this;
      console.log(file);
      if (file.add_user != util.getLocalStorage("openid")) {
        Dialog.alert({
          title: "删除产权证照片",
          message: "不可删除非本人上传产权照片，若要删除请联系业务人员",
        }).then(() => {
          // on close
        });

        return false
      }
      axios({
        method: "post",
        url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=delrwpic&pic_path=" +
          file.pic_path +
          "&token=clientjcfy&rw_id=" +
          self.options.id,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          console.log(res.data);
          self.getImg();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    afterRead_WTS(file) {
      // 此时可以自行将文件上传至服务器
      this.WTSUrl = URL.createObjectURL(file.file);
      var info = new FormData();
      info.append("sfz", file.file);
      axios({
        method: "post",
           url:
          "http://wx.beijinghome.cc/Contract/api/capi?api_name=uploadweituo&pic_type=sfzzm&token=clientjcfy&gzhid=" +
          util.getLocalStorage("openid")+"&line_id="+this.options.line_id,
        data: info,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    },
    reUploadWTS() {
      this.WTSUrl = '';
    },
  },
  created() {
    this.$store.commit("changeTitle", "合同订单");
    util.hideLoading();
  },
};
</script>
<style lang="scss" scoped>
.tobesigned-page {
  background: #ffffff;
  .jjr-block {
    position: relative;
    height: 5rem;
    .jjr-background {
      position: absolute;
      top: 0;
      background: #ecb94c;
      height: 2.8rem;
      width: 100%;
      display: inline-block;
      .jjr-pram1 {
        font-size: 0.4rem;
        color: #ffffff;
        margin: 0.6rem 0 0 0.4rem;
      }
      .jjr-pram2 {
        margin: 0.2rem 0 0 0.4rem;
        font-size: 0.26rem;
        color: #ffffff;
      }
    }
    .jjr {
      .rz-block {
        margin-top: 0.3rem;
        position: absolute;
        left: 0.4rem;
        top: 1.8rem;
        .line-block {
          width: 6.7rem;
          //   height: 1.4rem;
          background: #ffffff;
          box-shadow: 0rem 0rem 0.06rem #d3d3d3;
          margin: 0 auto;
          border-radius: 0.08rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .card-icon {
            margin-left: 0.2rem;
            margin-right: 0.2rem;
            .card-icon-img {
              display: inline-block;
              width: 1.15rem;
              border-radius: 1.15rem;
            }
          }
          .card-text {
            padding: 0.3rem;
            // height: 1.4rem;
            line-height: 0.5rem;

            .lx-font {
              font-size: 0.32rem;
              font-weight: 600;
              line-height: 0.65rem;
              margin-top: 0.1rem;
            }
            .s-font {
              font-size: 0.26rem;
            }
          }
          .card-statu {
            margin-right: 0.2rem;
            width: 2rem;
            .statu-text1 {
              color: #ecb94c;
              font-size: 0.3rem;
              color: #ffffff;
              background: #3bc48c;
              border-radius: 0.05rem;
              padding: 0.3rem;
            }
            .statu-text2 {
              color: #ecb94c;
              font-size: 0.3rem;
              color: #ffffff;
              background: #2e72ef;
              border-radius: 0.05rem;
              padding: 0.3rem;
            }
          }
        }
      }
    }
  }
  .ht-block {
    width: 6.7rem;
    margin: 0 0.5rem 0rem 0.5rem;
    padding-bottom: 3rem;

    .ht-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.01rem solid #e5e5e5;
      margin-bottom: 0.4rem;
      padding-bottom: 0.4rem;
      .ht-line-text {
        .ht-line-text-title {
          font-size: 0.4rem;
          color: #333333;
        }
        .ht-line-text-content {
          font-size: 0.24rem;
          color: #8d8f8e;
          margin-top: 0.2rem;
          line-height: 0.4rem;
        }
        width: 4.5rem;
      }
      .ht-line-button {
        font-size: 0.3rem;
        color: #ffffff;
        border-radius: 0.05rem;
        background: #f9543e;
        width: 1.7rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        width: 1.8rem;
      }
      .ht-line-button-end {
        font-size: 0.3rem;
        color: #ffffff;
        border-radius: 0.05rem;
        background: #ecb94c;
        width: 1.7rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        width: 1.8rem;
      }
    }
  }
}

.jjr-block-bottom {
  .rz-block {
    margin-top: 0.3rem;
    position: fixed;
    bottom: 0rem;
    .line-block {
      width: 7.5rem;
      height: 1.4rem;
      background: #ffffff;
      box-shadow: 0rem 0rem 0.06rem #d3d3d3;
      margin: 0 auto;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-icon {
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        .card-icon-img {
          display: inline-block;
          width: 1.15rem;
          border-radius: 1.15rem;
        }
      }
      .card-text {
        width: 2rem;
        height: 1.4rem;

        .lx-font {
          font-size: 0.32rem;
          font-weight: 600;
          line-height: 0.65rem;
          margin-top: 0.1rem;
        }
        .s-font {
          font-size: 0.2rem;
        }
      }
      .card-statu {
        margin-right: 0.2rem;
        width: 2rem;
        .statu-text1 {
          color: #ecb94c;
          font-size: 0.3rem;
          color: #ffffff;
          background: #3bc48c;
          border-radius: 0.05rem;
          padding: 0.3rem;
          text-align: center;
        }
        .statu-text2 {
          color: #ecb94c;
          font-size: 0.3rem;
          color: #ffffff;
          background: #2e72ef;
          border-radius: 0.05rem;
          padding: 0.3rem;
          text-align: center;
        }
      }
    }
  }
}
.avatar {
  width: 100%;
  height: auto;
}
</style>
